import React from 'react';
import FileUploadReportForm from '../FileUploadReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const FaceMatchInputComponent = () => (
    <FileUploadReportForm
        banner={{ icon: 'pi-users', title: 'Face Match', subtitle: 'Match a selfie against an ID-card photo via Surepass face matching' }}
        fileFields={[
            { name: 'selfie', label: 'Selfie', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-6' },
            { name: 'id_card', label: 'ID card photo', accept: 'image/*', maxSizeBytes: 5 * 1024 * 1024, hint: 'JPG / PNG up to 5 MB', colClass: 'col-12 md:col-6' },
        ]}
        endpoint={{ path: '/surepass/face/match' }}
        consentReportType="face-match"
        submitLabel="Match Faces"
        successSummary="Face match complete"
        errorSummary="Face match failed"
        confirmHeader="Confirm face match"
        confirmAcceptLabel="Yes, match"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Face Match Result', icon: 'pi-users' }}
    />
);

export default FaceMatchInputComponent;
